module.exports = __webpack_public_path__ + "img/popup_button5_unselected.2ee2bf8b.png";